import './lib.bundle.js';
import 'regenerator-runtime/runtime';

import * as Util from './util.bundle.js';
import * as Shell from './shell.bundle.js';
import * as Components from './components.bundle.js';

if (!global.hasOwnProperty('Promega'))
    global.Promega = { Util, Shell, Components };
